//Controls
import { Modal, ModalBody, ModalFooter, Button } from "@gpstrackit/react-controls";

//Components
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";

import { JsonView, allExpanded, darkStyles, defaultStyles } from 'react-json-view-lite';
import 'react-json-view-lite/dist/index.css';

//Actions
import { scheduledReportsOpenModal } from 'Redux/actions';
import { copyToClipboard } from 'Core/data/Helpers';

const DetailsScheduledReports = (props) => {
    const dispatch = useDispatch();
    const { messages } = useIntl();

    const [data, setData] = useState("");
    const { detail, openModal } = useSelector(state => state.scheduledReportsRedux);

    const closeModal = () => {
        dispatch(scheduledReportsOpenModal(false))
    }

    useEffect(() => {
        if (detail && openModal) {
            try {
                let newDetail = JSON.parse(JSON.parse(detail));
                if (newDetail?.UIParams)
                    newDetail.UIParams = newDetail?.UIParams?.id ? newDetail.UIParams : JSON.parse(newDetail?.UIParams)
                setData(newDetail);
            } catch (error) {
                console.log(error);
            }
        }
    }, [openModal])

    return (
        <Modal
            open={openModal}
            title={messages['scheduled_reports_params']}
            loading={false}
            position="right"
            size="small"
            handleClose={closeModal}
        >
            <ModalBody>
                <div style={{ padding: '0 10px', marginBottom: 30 }}>
                    {data && <JsonView data={data} shouldExpandNode={allExpanded} style={defaultStyles} />}
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn btn-cancel"
                    onClick={(e) => {
                        copyToClipboard(JSON.stringify(data), messages['common_copied'])
                    }}
                >
                    {messages['show_raw_data_modal_copy']}
                </Button>
                <Button
                    className="btn-dark-blue"
                    onClick={() => closeModal()}
                >
                    {messages['close']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}
export default DetailsScheduledReports;